import { render, staticRenderFns } from "./CallHistoryLog.vue?vue&type=template&id=be0ea5b2&"
import script from "./CallHistoryLog.vue?vue&type=script&lang=ts&"
export * from "./CallHistoryLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports